import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKalemNot_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKalemNot_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  UpdateKalemNot: number;
  UpdateKalemNot_dummy: number;
}

export class KalemNot_ScreenBase extends React.PureComponent<
  IKalemNot_ScreenProps,
  any
> {
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "SAVE",
          TagName: "Button1_label",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "Guardar",
          TagName: "Button1_label",
        },
        {
          Id: 173795,
          PropertyName: "value",
          Value: "Añadir al carrito",
          TagName: "Label17_0_value",
        },
        {
          Id: 970625,
          PropertyName: "value",
          Value: "Añadir al carrito seleccionando la marca y la cantidad.",
          TagName: "Label20_value",
        },
        {
          Id: 419427,
          PropertyName: "value",
          Value: "Marca",
          TagName: "Label3_value",
        },
        {
          Id: 380545,
          PropertyName: "value",
          Value: "Cantidad",
          TagName: "Label2_value",
        },
        {
          Id: 4746454,
          PropertyName: "ea063887-f63a-1e59-5d26-2f87ea7866f9_notify",
          Value: "El producto se ha añadido al carrito de la compra.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 81869038,
          PropertyName: "749a4704-faf8-ab66-efe6-8b00e71eaa90_notify",
          Value:
            "No se ha encontrado la marca. Ponte en contacto con tu representante de atención al cliente.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 86981060,
          PropertyName: "e41f7164-e01c-f00b-facc-8ab3679e473a_notify",
          Value: "El producto se ha añadido a la carrito de la compra.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 76414613,
          PropertyName: "af716684-6237-225f-f0ca-e28fe11ca7a5_notify",
          Value:
            "No se ha encontrado la marca. Ponte en contacto con tu representante de atención al cliente.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 46059390,
          PropertyName: "b965e2a1-ab9b-8a87-9663-b336ce0c017f_notify",
          Value: "El producto se ha añadido al carrito de la compra.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 61935789,
          PropertyName: "f06c6905-af27-7d5e-1a3b-8a80418f91bf_notify",
          Value: "El producto se ha añadido a la carrito de la compra.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "Enregistrer",
          TagName: "Button1_label",
        },
        {
          Id: 173795,
          PropertyName: "value",
          Value: "Ajouter au panier",
          TagName: "Label17_0_value",
        },
        {
          Id: 970625,
          PropertyName: "value",
          Value:
            "Vous pouvez ajouter au panier en sélectionnant la marque et la quantité",
          TagName: "Label20_value",
        },
        {
          Id: 419427,
          PropertyName: "value",
          Value: "Marque",
          TagName: "Label3_value",
        },
        {
          Id: 380545,
          PropertyName: "value",
          Value: "Quantité",
          TagName: "Label2_value",
        },
        {
          Id: 37233179,
          PropertyName: "ea063887-f63a-1e59-5d26-2f87ea7866f9_notify",
          Value: "Produit ajouté au panier de commande",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 59532477,
          PropertyName: "749a4704-faf8-ab66-efe6-8b00e71eaa90_notify",
          Value:
            "Marque introuvable. Veuillez contacter votre représentant commercial",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 9939154,
          PropertyName: "e41f7164-e01c-f00b-facc-8ab3679e473a_notify",
          Value: "Produit ajouté au panier d'offre",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 64473263,
          PropertyName: "af716684-6237-225f-f0ca-e28fe11ca7a5_notify",
          Value:
            "Marque introuvable. Veuillez contacter votre représentant commercial",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 54892845,
          PropertyName: "b965e2a1-ab9b-8a87-9663-b336ce0c017f_notify",
          Value: "Produit ajouté au panier de commande",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 71274190,
          PropertyName: "f06c6905-af27-7d5e-1a3b-8a80418f91bf_notify",
          Value: "Produit ajouté au panier d'offre",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "61ab7439-3a65-4d31-928b-bcf30ac115d0",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 47352, PropertyName: "value", Value: "Kalem Not" },
        { Id: 64155, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      UpdateKalemNot: 0,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kalemnot", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("kalemnot", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kalemnot", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      kalemnot_521187_value:
        this.props.screenInputs.KalemNot ?? this.props.screenInputs.kalemnot,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KalemNotComponent_713884_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KalemNotComponent_64155_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      kalemNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kalemnot_521187_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.id ?? this.props.screenInputs.id,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KalemNot/KalemNotComponent_64155_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateKalemNot = result?.data.updateKalemNot;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KalemNotComponent_64155_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KalemNotComponent_64155_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
